import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { SCHOOLS } from "./site/siteData";

export const isMaster = (user) => user?.role === "admin" && !user?.school_id;

export const schoolName = (id) => SCHOOLS.find((s) => s.slug === id)?.name || "Both schools";

export const SchoolSelect = ({ value, onChange, allowBoth = false, testId = "school-select" }) => (
  <div>
    <Label>School *</Label>
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger className="mt-1" data-testid={testId}><SelectValue placeholder="Choose school" /></SelectTrigger>
      <SelectContent>
        {SCHOOLS.map((s) => <SelectItem key={s.slug} value={s.slug}>{s.name}</SelectItem>)}
        {allowBoth && <SelectItem value="both">Both schools (master admin)</SelectItem>}
      </SelectContent>
    </Select>
  </div>
);
